import { IAppState } from '../../types/redux';

/**
 * @todo Удалить после завершения эксперимента
 * @description Данный функционал появился в задаче CD-253014, будет удалён в задаче 	CD-253668
 */
export function selectShowFullList(state: IAppState) {
  return state.showFullList;
}
